import { createContext, useContext, useRef, useState } from "react";
import { uploadFile } from "../utils/api";

const UploadContext = createContext(null);

export const UploadProvider = ({ children }) => {
  const pendingFilesRef = useRef({});
  const [pendingFileName, setPendingFileName] = useState({});
  const [uploadedFileName, setUploadedFileName] = useState({});

  const storeFile = (fieldName, file) => {
    pendingFilesRef.current[fieldName] = file || null;
	setPendingFileName(prev => ({
    ...prev,
    [fieldName]: file ? file.name : ""
  }));
  };

  const hasPendingFile = (fieldName) => {
    return !!pendingFilesRef.current[fieldName];
  };

  const clearPending = (fieldName) => {
	pendingFilesRef.current[fieldName] = null;
	setPendingFileName((prev) => ({ ...prev, [fieldName]: "" }));
  };
	  
  const uploadOne = async (fieldName) => {
	  const token = sessionStorage.getItem("token");
	  const file = pendingFilesRef.current[fieldName];
	  if (!token || !file) return false;

	  const result = await uploadFile({ file });

	  setUploadedFileName(prev => ({
		...prev,
		[fieldName]: result?.filename || file.name
	  }));

	  pendingFilesRef.current[fieldName] = null;

	  setPendingFileName(prev => ({
		...prev,
		[fieldName]: ""
	  }));

	  return true;
	};

  const uploadPendingFiles = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) return;

    const entries = Object.entries(pendingFilesRef.current);

    for (const [fieldName, file] of entries) {
      if (!file) continue;

      try {
        await uploadOne(fieldName);
      } catch (err) {
        console.error(`Upload failed for ${fieldName}`, err);
      }
    }
  };

  const handleSelectedFile = async (fieldName, file) => {
  storeFile(fieldName, file);

  if (sessionStorage.getItem("token") && file) {
    await uploadOne(fieldName);
    return true;            // ✅ uploaded immediately
  }

  return false;             // ✅ stored only (no token)
};

  return (
    <UploadContext.Provider
      value={{
        uploadedFileName,
        storeFile,
        hasPendingFile,
        uploadOne,
        uploadPendingFiles,
        handleSelectedFile,
		pendingFileName,
      }}
    >
      {children}
    </UploadContext.Provider>
  );
};

export const useUpload = () => {
  const context = useContext(UploadContext);

  if (!context) {
    throw new Error("useUpload must be used inside UploadProvider");
  }

  return context;
};